import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { CoachesProvider } from '../providers/coaches-provider';
import { Observable, switchMap, throwError } from "rxjs";
import { OrganizationsProvider } from "../../organizations/providers/organizations-provider";
import { Organization } from "../../common/models/organization";
import { catchError } from "rxjs/operators";
import { User } from "../../common/models/user";


export function CoachResolver(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User> {
  const coachesProvider = inject(CoachesProvider);
  const organizationsProvider = inject(OrganizationsProvider);
  const code = route.paramMap.get('organizationCode');
  if (!code) throw new Error('Organization code is required');
  return organizationsProvider.getByCode(code).pipe(
    switchMap((organization: Organization) => {
      return coachesProvider.get(organization.id!, +route.params['coachId']);
    }),
    catchError((error) => {
      console.error("CoachResolver : ", error);
      return throwError(() => new Error('Failed to retrieve athlete data'));
    }),
  );
}









//
// @Injectable({
//     providedIn: 'root'
// })
// export class CoachResolver implements Resolve<Coach> {
//     constructor(
//         private coachesProvider: CoachesProvider,
//     ) { }
//
//     public resolve(
//         route: ActivatedRouteSnapshot,
//         state: RouterStateSnapshot
//     ): Observable<any> {
//         return this.coachesProvider.get(+route.params['organizationId'], +route.params['coachId']);
//
//     }
// }
